import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getUserData } from "../services/api/AuthApi";

// Helper function to extract text from Draft.js content
const extractDraftJsText = (description) => {
  try {
    if (!description) return '';
    const parsed = typeof description === 'string' ? JSON.parse(description) : description;
    return parsed.blocks?.map(block => block.text).join('\n') || '';
  } catch {
    return description || '';
  }
};

export const exportTasksToExcel = async (tasks, showToast) => {
  if (!tasks || tasks.length === 0) {
    if (typeof showToast === 'function') {
      showToast("No tasks to Export", "error");
    } 
    return;
  }

  const userIds = new Set();
  tasks.forEach(task => {
    if (task.assignedBy) userIds.add(task.assignedBy);
    if (Array.isArray(task.assignedTo)) {
      task.assignedTo.forEach(id => userIds.add(id));
    } else if (task.assignedTo) {
      userIds.add(task.assignedTo);
    }
  });

  const userIdToNameMap = {};
  await Promise.all([...userIds].map(async (id) => {
    try {
      console.log(id, "shh");
      const res = await getUserData(id);
      userIdToNameMap[id] = res?.data?.name || "Unknown User";
    } catch {
      userIdToNameMap[id] = "Unknown User";
    }
  }));

  const formattedTasks = tasks.map((task) => ({
    Task_Name: task.taskName,
    Description: extractDraftJsText(task.description),
    Court_Reference: task.courtRef,
    Assigned_By: userIdToNameMap[task.assignedBy] || task.assignedBy,
    Assigned_To: Array.isArray(task.assignedTo)
      ? task.assignedTo.map(id => userIdToNameMap[id] || id).join(", ")
      : (userIdToNameMap[task.assignedTo] || task.assignedTo),
    Due_Date: new Date(task.dueDate).toLocaleDateString(),
    Is_Completed: task.isCompleted ? "Yes" : "No",
    Recurrence: task.recurringTask ? `${task.recurringTask.times} ${task.recurringTask.in}` : "None",
    Document_Link: task.document,
    Created_At: new Date(task.createdAt).toLocaleString(),
    Updated_At: new Date(task.updatedAt).toLocaleString(),
  }));

  const worksheet = XLSX.utils.json_to_sheet(formattedTasks);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Tasks");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "Tasks.xlsx");
};